module.exports = __webpack_public_path__ + "img/梁庄镇-c.8203d83f.png";